import React from "react";
import { Link } from "react-router-dom";
import { Box, Text, Button } from "@chakra-ui/react";
import { NotVerifiedIcon } from "../../components/otp/otpIcon";
import styles from "./styles.module.css";

function NotVerifiedPage() {
  return (
    <Box className={styles["notVerified__main-container"]}>
      <Box className={styles["notVerified__submain-container"]}>
        <NotVerifiedIcon />
        <Text className={styles["notVerified__register-title"]}>
          Verifikasi Belum Selesai
        </Text>
        <Text className={styles["notVerified__register-subtitle"]}>
          Verifikasi akun membership Anda belum selesai. Silakan selesaikan
          proses verifikasi.
        </Text>
        <Link to={"/verification"}>
          <Button
            className={styles["notVerified__button-text"]}
            background="#FFFFFF"
            borderRadius="4px"
            width="257px"
          >
            Kembali
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default NotVerifiedPage;
